import { render, staticRenderFns } from "./DisregardRiskFarmDialog.vue?vue&type=template&id=6d20210e&scoped=true"
import script from "./DisregardRiskFarmDialog.vue?vue&type=script&lang=js"
export * from "./DisregardRiskFarmDialog.vue?vue&type=script&lang=js"
import style0 from "./DisregardRiskFarmDialog.vue?vue&type=style&index=0&id=6d20210e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20210e",
  null
  
)

export default component.exports